import type {RgbBlendType} from "#material/nodes/color/mix-rgb/validation"
import type {CyclesBlendMode} from "#material/cycles/types"

export const cyclesMixType = (blendType?: RgbBlendType): CyclesBlendMode | undefined => {
    if (!blendType) {
        return undefined
    }
    switch (blendType) {
        case "MIX":
            return "mix"
        case "ADD":
            return "add"
        case "MULTIPLY":
            return "multiply"
        case "SCREEN":
            return "screen"
        case "OVERLAY":
            return "overlay"
        case "SUBTRACT":
            return "subtract"
        case "DIVIDE":
            return "divide"
        case "DIFFERENCE":
            return "difference"
        case "DARKEN":
            return "darken"
        case "LIGHTEN":
            return "lighten"
        case "DODGE":
            return "dodge"
        case "BURN":
            return "burn"
        case "HUE":
            return "hue"
        case "SATURATION":
            return "saturation"
        case "VALUE":
            return "value"
        case "COLOR":
            return "color"
        case "SOFT_LIGHT":
            return "soft_light"
        case "LINEAR_LIGHT":
            return "linear_light"
        case "EXCLUSION":
            return "exclusion"
    }
}
